export const globalLoaderSelector = (state) => state.loader.globalLoader.status;
